// extracted by mini-css-extract-plugin
module.exports = {"spinner":"_7a3fb80146--spinner--AwrPk","circle-spin":"_7a3fb80146--circle-spin--Y8vnP"};